var splitDate = function (locale, date, format) {
    if (format === void 0) { format = {}; }
    var _a = format.year, year = _a === void 0 ? 'numeric' : _a, _b = format.month, month = _b === void 0 ? 'numeric' : _b, _c = format.day, day = _c === void 0 ? 'numeric' : _c;
    return {
        year: new Intl.DateTimeFormat(locale, { year: year }).format(date),
        month: new Intl.DateTimeFormat(locale, { month: month }).format(date),
        day: new Intl.DateTimeFormat(locale, { day: day }).format(date),
    };
};
var modifiedShortDates = {
    fi: function (date) {
        var _a = splitDate('fi', date), day = _a.day, month = _a.month, year = _a.year;
        return day + "." + month + "." + year;
    },
    ko: function (date) {
        var _a = splitDate('ko', date, {
            month: '2-digit',
            day: '2-digit',
        }), day = _a.day, month = _a.month, year = _a.year;
        return (year + "." + month + "." + day).replace(/년|월|일/g, '');
    },
    sk: function (date) {
        return new Intl.DateTimeFormat('sk').format(date).replace(/ /g, '');
    },
    nn: function (date) {
        return new Intl.DateTimeFormat('nn').format(date).replace(/\//g, '.');
    },
    'es-US': function (date) {
        var _a = splitDate('es-US', date), day = _a.day, month = _a.month, year = _a.year;
        return month + "/" + day + "/" + year;
    },
    sv: function (date) {
        var _a = splitDate('sv', date), day = _a.day, month = _a.month, year = _a.year;
        return day + "/" + month + " " + year;
    },
};
/**
 * Function that returns short date format approved by Wix Localization team.
 * @param locale - language/country short value that is passed to Intl.DateTimeFormat
 * @param date - JavaScript Date objects represent a single moment in time in a platform-independent format.
 */
export var getShortDate = function (locale, date) {
    var _a;
    if (modifiedShortDates[locale]) {
        return (_a = modifiedShortDates[locale]) === null || _a === void 0 ? void 0 : _a.call(modifiedShortDates, date);
    }
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
};
//# sourceMappingURL=getShortDate.js.map